<template>
  <div class="table1">
    <el-table :data="list" height="850" style="width: 100%" ref="table" @sort-change='sortChange'>
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div @click="gotoinfo(scope.row)" style="cursor: pointer;">
            <div style="font-size: 15px; color: #333333">{{ scope.row.ths_fund_short_name_fund || '--'}}</div>
            <div style="font-size: 13px; color: #999999">{{ scope.row.code || '--'}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_chg_ratio_fund" label="日涨跌幅" align="center" sortable='custom' >
        <template slot-scope="scope">
          <div style="font-size: 15px">
            {{ scope.row.ths_chg_ratio_fund || '--'}} <i v-if="scope.row.ths_chg_ratio_fund">%</i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_fund_scale_fund" label="总资产规模" align="center" sortable>
        <template slot-scope="scope">
          <div style="font-size: 15px">
            {{ scope.row.ths_fund_scale_fund || '--'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_unit_nv_fund" label="单位净值" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_unit_nv_fund || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_conversion_premium_rate_cbond" label="近一周收益率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_conversion_premium_rate_cbond || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_yeild_1w_fund" label="近一月收益率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_yeild_1w_fund || '--'}} <i v-if="scope.row.ths_yeild_1w_fund">%</i></template>
      </el-table-column>
      <el-table-column prop="ths_yeild_3m_fund" label="近三月收益率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_yeild_3m_fund || '--'}}<i v-if="scope.row.ths_yeild_3m_fund">%</i></template>
      </el-table-column>
      <el-table-column prop="ths_yeild_6m_fund" label="近六月收益率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_yeild_6m_fund || '--'}}<i v-if="scope.row.ths_yeild_6m_fund">%</i></template>
      </el-table-column>
      <el-table-column prop="ths_yeild_1y_fund" label="近一年收益率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_yeild_1y_fund || '--'}}<i v-if="scope.row.ths_yeild_1y_fund">%</i></template>
      </el-table-column>
      <el-table-column prop="ths_yeild_ytd_fund" label="今年以来收益率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_yeild_ytd_fund || '--'}}<i v-if="scope.row.ths_yeild_ytd_fund">%</i></template>
      </el-table-column>
      <el-table-column prop="ths_annual_adjustment_nvg_ratio_fund" label="年化收益率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_annual_adjustment_nvg_ratio_fund || '--'}}<i v-if="scope.row.ths_annual_adjustment_nvg_ratio_fund">%</i></template>
      </el-table-column>
      <el-table-column prop="ths_yeild_std_fund" label="成立以来收益率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_yeild_std_fund || '--'}}<i v-if="scope.row.ths_yeild_std_fund">%</i></template>
      </el-table-column>
      <el-table-column prop="ths_manage_fee_rate_fund" label="费率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_manage_fee_rate_fund || '--'}}<i v-if="scope.row.ths_manage_fee_rate_fund">%</i></template>
      </el-table-column>
      <!-- <el-table-column prop="data17" label="操作" align="center">
        <template>
          <img src="../../../../public/img/index3/add.png" alt="" />
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import {cbondList} from '../../../http/index.js'
export default {
  props:{
    list:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data() {
    return {
      // list:[],
      page:1,
      page_number:20,
      sortObj:{},
    };
  },

  mounted() {
    // this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 850 * this.page
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    gotoinfo(e){
      let codes = e.codes
      let canshu = Object.assign({},{codes})
      let codes2 = canshu.codes.slice(0,6)
      let codes3 = canshu.codes.slice(7)
      let canshu2 = `${codes3}${codes2}.html`
      this.$router.push({path:`/fund/${canshu2}`})
    },
    getMore() {
      this.page++
      // this.getlist()
      this.$emit('getmorelist')
    },
    initpage(){
      this.page = 1
    },
    getlist(){
      this.$emit('getlist')
    },
    sortChange(a){
      this.page = 1
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}

        this.$emit('changelist')
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.$emit('changelist',obj)
      }
    }
  }
};
</script>

<style scoped>
.table1 {
  min-width: 1427px;
  position: relative;
  overflow-x: scroll;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table1 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table1 /deep/ .cell{
  padding: 0;
}
.table1 /deep/ .el-table th.el-table__cell>.cell{
  padding:  0;
  
}
</style>